import { render, staticRenderFns } from "./cnyRecord.vue?vue&type=template&id=18ea6c38&scoped=true&"
import script from "./cnyRecord.vue?vue&type=script&lang=js&"
export * from "./cnyRecord.vue?vue&type=script&lang=js&"
import style0 from "./cnyRecord.vue?vue&type=style&index=0&id=18ea6c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ea6c38",
  null
  
)

export default component.exports